import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { ApplicationSdk } from ".";
import { upload } from "@testing-library/user-event/dist/upload";

/**
 * Load all managers and make it possible to manage them
 */
class DocumentStore {
    private sdk: ApplicationSdk;

    public documentLoading: boolean = false;

    public pdf_signed_url: string | null = null;
    public pdf_file: string | null = null;
    public pdf_file_signed: string | null = null;


    constructor(sdk: ApplicationSdk) {
        makeObservable(this, {
            documentLoading: observable,
            pdf_file: observable,
            pdf_file_signed: observable,
            pdf_signed_url: observable,
            signDocument: action
        });

        this.sdk = sdk;
    }

    public async init(): Promise<void> {
        this.fetchPdfDocumentInfo();
    }

    public async fetchPdfDocumentInfo(): Promise<void> {
        runInAction(() => {
            this.documentLoading = true;
        });

        const pdfDocumentInfoResult: any = await this.sdk.fetchApiFile(
            'signabledocuments',
            this.sdk.locationAction || '');

        runInAction(async () => {
            this.documentLoading = false;

            if (pdfDocumentInfoResult?.status === 200) {
                this.pdf_file = await pdfDocumentInfoResult.blob;
            }
        });
    }

    public async onDialogLeave(dialog: string, event: any = null): Promise<void> {
    }

    public onLeaveStore(): void {
    }

    public async signDocument(newBlob: any): Promise<boolean> {
        this.pdf_file_signed = newBlob;
        //@ts-ignore
        // this.pdf_file_signed.file =  await newBlob.arrayBuffer();
        // const mergedPdfBuffer = await newBlob.arrayBuffer();
        // console.log(new File([newBlob], 'signiertes-dokument.pdf', { type: 'application/pdf' }))
        // console.log('Merging PDF buffer:', mergedPdfBuffer);


        const uploadResult = await this.sdk.uploadImage(
            'signabledocuments',
            `${this.sdk.locationAction || ''}/upload`,
            new File([newBlob], 'signiertes-dokument.pdf', { type: 'application/pdf' })
        );

        if (uploadResult?.status === 200) {
            const { url } = uploadResult.json;

            console.log('Signed PDF URL:', uploadResult.json);
            runInAction(() => {
                this.pdf_signed_url = url;
            });

            return true;
        }

        return false;
    }
}

export default DocumentStore;